export const userKey = "user";
export const tokenKey = "token";

const saveUser = (user) => {
  sessionStorage.setItem(userKey, JSON.stringify(user));
};

const getUser = () =>
sessionStorage.getItem(userKey) ? JSON.parse(sessionStorage.getItem(userKey)) : null;

const saveAuthToken = (token) => {
  sessionStorage.setItem(tokenKey, token);
};

const getAuthToken = () => {
  return sessionStorage.getItem(tokenKey);
};

const resetUser = () => {
  sessionStorage.setItem(userKey, "");
};

const resetAuthToken = () => {
  sessionStorage.setItem(tokenKey, "");
};

const resetAll = () => {
  sessionStorage.setItem(userKey, "");
  sessionStorage.setItem(tokenKey, "");
};

export default {
  saveUser,
  getUser,
  saveAuthToken,
  getAuthToken,

  resetUser,
  resetAuthToken,
  resetAll,
};
